var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.313 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon metro-bin",
    d: "M1.563 7.813v15.625A1.567 1.567 0 003.126 25h14.062a1.567 1.567 0 001.563-1.562V7.813H1.563zm4.688 14.059H4.688V10.938h1.563zm3.125 0H7.813V10.938h1.563zm3.126 0h-1.564V10.938h1.564zm3.125 0h-1.564V10.938h1.563zm3.516-18.75h-5.08v-1.95A1.175 1.175 0 0012.891 0H7.423a1.175 1.175 0 00-1.172 1.172v1.953H1.173A1.175 1.175 0 00.002 4.297V6.25h20.311V4.297a1.175 1.175 0 00-1.172-1.172zm-6.641.003H7.813V1.582h4.689v1.543z",
    fill: "#8d8c8c",
    opacity: 0.75
  })));
}

export default __webpack_public_path__ + "370a72e9271ada081335422a21c09ba1.svg";
export { SvgDelete as ReactComponent };